module.exports = __webpack_public_path__ + "static/media/2.12c1d748.jpg";